"use strict";

var breakpoints = [40, 52, 64];

var scale = [0, 8, 16, 32, 64];

var fontSizes = [12, 14, 16, 20, 24, 32, 48, 64, 72];

module.exports = {
  breakpoints: breakpoints,
  scale: scale,
  fontSizes: fontSizes
};


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/constants.js
// module id = 106
// module chunks = 0